/* Avoir Official theme */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var T = window.theme || { routes: {}, strings: {} };

  function formatMoney(cents) {
    var fmt = T.moneyFormat || '${{amount}}';
    function withDelims(n, d, t, dec) {
      n = (n / 100).toFixed(d);
      var parts = n.split('.');
      return parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + t) + (parts[1] ? dec + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return withDelims(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(cents, 2, "'", '.');
        default: return withDelims(cents, 2, ',', '.');
      }
    });
  }

  /* ---------- phone menu ---------- */
  function initDrawer() {
    var drawer = $('#drawer'), scrim = $('#scrim'), btn = $('#open-menu');
    if (!drawer || !btn) return;
    function set(on) {
      drawer.classList.toggle('on', on); scrim.classList.toggle('on', on);
      drawer.setAttribute('aria-hidden', !on); btn.setAttribute('aria-expanded', on);
      document.body.classList.toggle('locked', on);
      if (on) { var f = drawer.querySelector('a,button'); if (f) f.focus(); }
    }
    btn.addEventListener('click', function () { set(true); });
    $('#close-menu').addEventListener('click', function () { set(false); btn.focus(); });
    scrim.addEventListener('click', function () { set(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('on')) { set(false); btn.focus(); } });
    $$('.d-toggle', drawer).forEach(function (b) {
      b.addEventListener('click', function () {
        var sub = document.getElementById(b.getAttribute('aria-controls'));
        var on = b.getAttribute('aria-expanded') !== 'true';
        b.setAttribute('aria-expanded', on); sub.classList.toggle('on', on);
      });
    });
  }

  /* ---------- toast + cart count ---------- */
  var toastTimer;
  function toast(msg, thumb, link) {
    var t = $('#toast'); if (!t) return;
    $('#toast-msg').innerHTML = '';
    $('#toast-msg').appendChild(document.createTextNode(msg));
    if (link) { var a = document.createElement('a'); a.href = link; a.textContent = T.strings.viewCart || 'View cart'; $('#toast-msg').appendChild(a); }
    $('#toast-thumb').style.backgroundImage = thumb ? 'url(' + thumb + ')' : '';
    $('#toast-thumb').style.display = thumb ? '' : 'none';
    t.classList.add('on'); clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('on'); }, 3200);
  }
  function refreshCount() {
    return fetch((T.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { $$('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.classList.toggle('on', c.item_count > 0); }); return c; })
      .catch(function () {});
  }

  /* ---------- product page ---------- */
  function initProduct(root) {
    var product; try { product = JSON.parse($('[data-product-json]', root.parentElement).textContent); } catch (e) { product = null; }
    var section = root, box = $('[data-product]', root); if (!box) return;
    var formId = box.getAttribute('data-form-id'), form = document.getElementById(formId);

    // gallery
    var track = $('[data-slides]', root), thumbs = $('[data-thumbs]', root), dots = $('[data-dots]', root), counter = $('[data-counter]', root);
    var slides = $$('.slide', track), n = slides.length, cur = 0;
    function go(i, smooth) { i = Math.max(0, Math.min(n - 1, i)); track.scrollTo({ left: i * track.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' }); }
    function mark(i) {
      cur = i;
      $$('.thumb', thumbs).forEach(function (t, k) { t.setAttribute('aria-current', k === i); });
      $$('.dot', dots).forEach(function (d, k) { d.setAttribute('aria-current', k === i); });
      if (counter) counter.textContent = (i + 1) + ' / ' + n;
      var p = $('[data-prev]', root), nx = $('[data-next]', root);
      if (p) p.disabled = i === 0; if (nx) nx.disabled = i === n - 1;
    }
    if (n > 1) {
      slides.forEach(function (s, i) {
        var img = $('img', s);
        var t = document.createElement('button'); t.type = 'button'; t.className = 'thumb'; t.setAttribute('aria-label', 'Photo ' + (i + 1));
        if (img) { var ti = document.createElement('img'); ti.src = img.currentSrc || img.src; ti.alt = ''; ti.loading = 'lazy'; t.appendChild(ti); }
        t.addEventListener('click', function () { go(i); }); thumbs.appendChild(t);
        var d = document.createElement('button'); d.type = 'button'; d.className = 'dot'; d.setAttribute('aria-label', 'Photo ' + (i + 1));
        d.addEventListener('click', function () { go(i); }); dots.appendChild(d);
      });
    }
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { var i = Math.round(track.scrollLeft / track.clientWidth); if (i !== cur) mark(i); });
    }, { passive: true });
    var pb = $('[data-prev]', root), nb = $('[data-next]', root);
    if (pb) pb.addEventListener('click', function () { go(cur - 1); });
    if (nb) nb.addEventListener('click', function () { go(cur + 1); });
    track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); } });
    window.addEventListener('resize', function () { track.scrollLeft = cur * track.clientWidth; });
    mark(0);
    function showMedia(id) { var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') == id; }); if (idx > -1) go(idx, false); }

    // variants
    var picker = $('[data-variant-picker]', root);
    var hint = $('[data-size-hint]', root);
    function selected() { return $$('.opt', picker).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; }); }
    function findVariant(opts) {
      if (!product || opts.some(function (o) { return o === null; })) return null;
      return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    function markAvailability(opts) {
      if ($$('.opt', picker).length < 2) return; // single option: sold-out sizes are disabled in the markup
      $$('.opt', picker).forEach(function (fs, idx) {
        $$('input', fs).forEach(function (inp) {
          var test = opts.slice(); test[idx] = inp.value;
          var v = product.variants.find(function (x) { return x.options.every(function (o, i) { return test[i] === null || o === test[i]; }); });
          inp.classList.toggle('unavailable', !v || !v.available);
        });
      });
    }
    function priceText(cents, sample) { var t = formatMoney(cents); var m = (sample || '').trim().match(/\s([A-Z]{3})$/); return m ? t + ' ' + m[1] : t; }
    function update(v) {
      var btns = $$('[data-add-button]'), msg = $('[data-form-msg]', root);
      if (msg) msg.textContent = '';
      $$('[data-variant-id]').forEach(function (i) { i.value = v ? v.id : ''; });
      if (!v) return;
      if (hint) hint.textContent = '';
      btns.forEach(function (b) { b.disabled = !v.available; b.textContent = v.available ? T.strings.addToCart : T.strings.soldOut; });
      var bn = $('[data-buy-now]', root); if (bn) bn.disabled = !v.available;
      var priceEl = $('[data-price]', root);
      if (priceEl) priceEl.textContent = priceText(v.price, priceEl.textContent);
      var q4 = $('[data-quarter]', root); if (q4) q4.textContent = formatMoney(Math.round(v.price / 4));
      var cmp = $('[data-compare]', root), sb = $('[data-sale-badge]', root), onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (cmp) { cmp.hidden = !onSale; if (onSale) cmp.textContent = formatMoney(v.compare_at_price); }
      if (sb) sb.hidden = !onSale;
      $$('[data-option-value]', root).forEach(function (el) { var i = +el.getAttribute('data-option-value'); el.textContent = '— ' + v.options[i]; });
      var sticky = $('[data-sticky-price]'); if (sticky) sticky.textContent = v.options.join(' / ') + ' · ' + (priceEl ? priceEl.textContent : formatMoney(v.price));
      if (v.featured_media && root.hasAttribute('data-switch-media')) showMedia(v.featured_media.id);
      if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); }
    }
    if (picker && product) {
      markAvailability(selected());
      picker.addEventListener('change', function () {
        var o = selected(); markAvailability(o);
        $$('.opt', picker).forEach(function (fs, i) { var sp = $('[data-option-value="' + i + '"]', root); if (sp && o[i]) sp.textContent = '— ' + o[i]; });
        var v = findVariant(o); if (v) update(v);
      });
    }
    function needsChoice() {
      var id = $('[data-variant-id]', form ? form : root);
      if (id && id.value) return false;
      if (hint) hint.textContent = T.strings.pickSize || 'Please select a size.';
      var s = $('.sizes', root); if (s) s.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return true;
    }

    // quantity
    $$('[data-qty]', root).forEach(function (q) {
      var inp = $('input', q);
      $$('[data-step]', q).forEach(function (b) { b.addEventListener('click', function () { inp.value = Math.max(1, Math.min(10, (parseInt(inp.value, 10) || 1) + (+b.getAttribute('data-step')))); }); });
    });

    // add to cart / buy it now
    function addToCart(goCheckout) {
      if (needsChoice()) return;
      var btns = $$('[data-add-button],[data-buy-now]'), msg = $('[data-form-msg]', root);
      btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.disabled = true; });
      var fd = new FormData(form);
      var q = document.getElementById('Quantity-' + section.getAttribute('data-section')); if (q) fd.set('quantity', q.value);
      fetch((T.routes.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) { if (msg) msg.textContent = res.j.description || res.j.message || 'Something went wrong. Please try again.'; return; }
          if (goCheckout) { location.href = '/checkout'; return; }
          var item = res.j;
          toast((T.strings.addedShort || 'Added') + ': ' + item.product_title + (item.variant_title ? ', ' + item.variant_title : '') + ' × ' + (q ? q.value : 1) + ' ', item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=120' : box.getAttribute('data-thumb'), T.routes.cart);
          refreshCount();
        })
        .catch(function () { if (msg) msg.textContent = 'Something went wrong. Check your connection and try again.'; })
        .finally(function () { btns.forEach(function (b) { b.removeAttribute('aria-busy'); b.disabled = false; }); });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(false); });
    $$('[data-buy-now]', root).forEach(function (b) { b.addEventListener('click', function () { addToCart(true); }); });

    // sticky bar on phones
    var sticky = $('[data-sticky-atc]'), main = $('#main-actions', root);
    if (sticky && main && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var e = es[0], past = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('on', past); sticky.setAttribute('aria-hidden', !past);
      }).observe(main);
    }

    // size guide modal
    var sec = root.closest('.shopify-section') || document; var modal = $('[data-size-modal]', sec), scrim = $('[data-size-scrim]', sec);
    if (modal) {
      var set = function (on) { modal.classList.toggle('on', on); scrim.classList.toggle('on', on); document.body.classList.toggle('locked', on); if (on) $('[data-close-size]', modal).focus(); };
      $$('[data-open-size]', sec).forEach(function (b) { b.addEventListener('click', function () { set(true); }); });
      $('[data-close-size]', modal).addEventListener('click', function () { set(false); });
      scrim.addEventListener('click', function () { set(false); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('on')) set(false); });
    }
  }

  /* ---------- copy buttons ---------- */
  function initCopy() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-copy],[data-copy-link]'); if (!b) return;
      var text = b.getAttribute('data-copy') || b.getAttribute('data-copy-link');
      var label = b.querySelector('span') || b, old = label.textContent;
      function done(m) { label.textContent = m; setTimeout(function () { label.textContent = old; }, 1800); }
      if (navigator.clipboard) navigator.clipboard.writeText(text).then(function () { done(T.strings.linkCopied || 'Copied'); }, function () { done(text); });
      else done(text);
    });
  }

  /* ---------- selects / checkboxes that submit their form ---------- */
  function initAutosubmit() {
    document.addEventListener('change', function (e) {
      var el = e.target.closest('[data-autosubmit]'); if (el && el.form) el.form.submit();
    });
  }

  /* ---------- open a collapsible row from a link ---------- */
  function initAnchors() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]'); if (!a) return;
      var id = a.getAttribute('href').slice(1); if (!id) return;
      var t = document.getElementById(id);
      if (t && t.tagName === 'DETAILS') { e.preventDefault(); t.open = true; t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  }

  /* ---------- cart page quantity ---------- */
  function initCart() {
    var sec = $('[data-cart-section]'); if (!sec) return;
    $$('[data-cart-qty]', sec).forEach(function (q) {
      var inp = $('input', q);
      function change(qty) {
        sec.style.opacity = '.6';
        fetch((T.routes.cartChange || '/cart/change') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +inp.getAttribute('data-line'), quantity: qty }) })
          .then(function () { location.reload(); })
          .catch(function () { sec.style.opacity = ''; });
      }
      $$('[data-step]', q).forEach(function (b) { b.addEventListener('click', function () { var v = Math.max(0, (parseInt(inp.value, 10) || 0) + (+b.getAttribute('data-step'))); inp.value = v; change(v); }); });
      inp.addEventListener('change', function () { change(Math.max(0, parseInt(inp.value, 10) || 0)); });
    });
    var note = $('#CartNote');
    if (note) note.addEventListener('change', function () {
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
    });
  }

  /* ---------- product recommendations ---------- */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (el) {
      fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
        var d = document.createElement('div'); d.innerHTML = html;
        var inner = d.querySelector('[data-recommendations] .cards'), mine = el.querySelector('.cards');
        if (inner && mine && inner.children.length) mine.innerHTML = inner.innerHTML;
      }).catch(function () {});
    });
  }

  /* ---------- collection: in-stock filter + sort (on this page) ---------- */
  function initCollection() {
    $$('[data-grid]').forEach(function (grid) {
      var wrap = grid.closest('.wrap'), cells = $$('.cell', grid), order = cells.slice();
      var sort = $('[data-sort]', wrap), stock = $('[data-instock]', wrap), count = $('[data-count]', wrap), none = $('[data-none]', wrap);
      function apply() {
        var how = sort ? sort.value : 'featured', only = stock && stock.checked, list = order.slice();
        if (how === 'low') list.sort(function (a, b) { return a.dataset.price - b.dataset.price; });
        if (how === 'high') list.sort(function (a, b) { return b.dataset.price - a.dataset.price; });
        if (how === 'az') list.sort(function (a, b) { return a.dataset.title.localeCompare(b.dataset.title); });
        var shown = 0;
        list.forEach(function (c) { var hide = only && c.dataset.soldout === '1'; c.hidden = hide; if (!hide) shown++; grid.appendChild(c); });
        if (count) count.textContent = shown + ' ' + (shown === 1 ? (T.strings.product || 'product') : (T.strings.products || 'products'));
        if (none) none.hidden = shown > 0;
      }
      if (sort) sort.addEventListener('change', apply);
      if (stock) stock.addEventListener('change', apply);
    });
  }

  /* ---------- live search ---------- */
  function initSearch() {
    var input = $('[data-live-search]'); if (!input) return;
    var results = $('[data-search-results]'), timer, ctrl;
    function run() {
      var q = input.value.trim();
      var url = (T.routes.search || '/search') + '?q=' + encodeURIComponent(q) + '&options[prefix]=last&section_id=' + input.getAttribute('data-section');
      if (ctrl) ctrl.abort(); ctrl = window.AbortController ? new AbortController() : null;
      fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.text(); }).then(function (html) {
        var d = document.createElement('div'); d.innerHTML = html;
        var fresh = d.querySelector('[data-search-results]'); if (fresh) results.innerHTML = fresh.innerHTML;
        if (history.replaceState) { var u = new URL(location.href); if (q) u.searchParams.set('q', q); else u.searchParams.delete('q'); history.replaceState({}, '', u.toString()); }
      }).catch(function () {});
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 250); });
    $$('[data-q]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); input.value = b.getAttribute('data-q'); run(); input.focus(); }); });
  }

  function boot() {
    initDrawer(); initCopy(); initAutosubmit(); initAnchors(); initCart(); initRecommendations(); initCollection(); initSearch();
    $$('[data-product-section]').forEach(initProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  // theme editor: re-run when a section is added or changed
  document.addEventListener('shopify:section:load', function (e) {
    var p = e.target.querySelector('[data-product-section]'); if (p) initProduct(p);
    if (e.target.querySelector('#drawer')) initDrawer();
    initRecommendations();
  });
})();

/* keeps --header-h equal to the height above the page content, so "Fit the screen" photos fit exactly */
(function () {
  function setHH() {
    var m = document.getElementById('MainContent'); if (!m) return;
    var h = Math.max(0, Math.round(m.getBoundingClientRect().top + window.scrollY));
    document.documentElement.style.setProperty('--header-h', h + 'px');
  }
  setHH(); window.addEventListener('load', setHH); window.addEventListener('resize', setHH);
  document.addEventListener('shopify:section:load', setHH);
})();
